import axios from "axios";
import moment from "moment/moment";

const NotificheStore = {
    state: () => ({
        notifiche: [],
        loadedNotifiche: false,
    }),
    mutations: {

        notificheLoaded(state, item) {
            let notifiche = [...item.sort((a, b) => b.createdAt - a.createdAt)];
            notifiche.forEach(notifica => {
                notifica.createdAt = epochToDate(notifica.createdAt);
            })
            state.notifiche = [...notifiche];
            state.loadedNotifiche = true;
            return item;
        },
        startGestioneNotifica(state, item) {
            return item;
        },
        notificaGestita(state, item){
            state.notifiche=state.notifiche.filter(not=>not.id!==item.idNotifica)
            return;
        },
        showDettaglioNotifica(state, item){
            return item;
        },
        notificaCreatedFromWs(state, item){
            state.notifiche.push(item);
            this.commit("notificheLoaded", state.notifiche);
        },
        notificaRemovedWs(state, item){
            state.notifiche=state.notifiche.filter(not=>not.idTaskSprint!==item)
            return;
        },
        allNotificheLoaded(state, item){
            let notificheSorted=item.sort((a, b) => b.createdAt - a.createdAt);
            notificheSorted.forEach(notifica => {
                notifica.createdAt = epochToDate(notifica.createdAt);
            });
            this.commit("viewModalAllNotifiche", notificheSorted);
        },
        viewModalAllNotifiche(state, item){
            return item;
        },
        reopenTutteLeNotifiche(state, item){
            return;
        }
    },
    actions: {
        async loadNotifiche({ commit }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit('addRequest')
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/notifiche/getNotificheDaGestire", {}, { adapter: 'fetch', fetchOptions: { priority: 'low' }, ...config })
                    .then(response => {
                        if (response.data.responseCode !== 200) {
                            commit('removeRequest');
                            commit("hideMiniLoader");
                            commit('addMessage', {
                                message: "VUEX loadNotifiche error: " + response.data.dettagli,
                                messageType: 'error'
                            });
                            return;
                        }
                        let result = JSON.parse(response.data.result);
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit("notificheLoaded", result);
                    }).catch(ex=>{
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit('addMessage', {
                            message:"VUEX loadNotifiche error: "+ex.message,
                            messageType:'error'
                        });
                    });
            } catch (e) {
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message: "VUEX loadNotifiche error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async salvaNotifica({ commit, getters }, data) {
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit('addRequest')
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/notifiche/gestisciNotifica", {
                    notifica:{...data.notifica, createdAt:undefined},
                    approvata: data.approvata,
                    messaggio:data.messaggio,

                }, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config })
                    .then(response => {
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        if (response.data.responseCode !== 200) {
                            throw new Error(response.data.dettagli)
                        }
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit("notificaGestita", {idNotifica:data.notifica.id});
                        commit("taskGestito", {idTaskSprint:data.notifica.idTaskSprint, approvato:data.approvata, messaggio: data.messaggio});
                        if (data.approvata===true && response.data.createNew && response.data.createNew === true) {
                            //Recupero il TS
                            let ts= getters.getTaskById(data.notifica.idTaskSprint);
                            if(ts.length>0){
                                commit("tuttiITaskCompletati", { task:{...ts[0]}, createNew:response.data.createNew, canCloseTicket: response.data.canCloseTicket, force:false, messaggioNotifica:data.notifica.messaggio });
                            }

                        }
                    }).catch(ex=>{
                        commit('removeRequest');
                        commit("hideMiniLoader");
                        commit('addMessage', {
                            message:"VUEX salvaNotifica error: "+ex.message,
                            messageType:'error'
                        });
                    });

            } catch (e) {
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message: "VUEX salvaNotifica error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async cambiaManagerNotifica({ commit }, data){
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/notifiche/cambiaManagerNotifiche", {
                    ...data

                }, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config })
                    .then(response => {
                        commit("hideMiniLoader");
                        if (response.data.responseCode !== 200) {
                            throw new Error(response.data.dettagli)
                        }
                        commit('removeRequest');
                        commit("hideMiniLoader");
                    }).catch(ex=>{
                    commit('removeRequest');
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX salvaNotifica error: "+ex.message,
                        messageType:'error'
                    });
                });

            } catch (e) {
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message: "VUEX salvaNotifica error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        async loadAllNotifiche({ commit }, data){
            try {
                const config = {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}` }
                };
                commit("showMiniLoader");
                axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/notifiche/getAllNotifiche", {
                }, { adapter: 'fetch', fetchOptions: { priority: 'high' }, ...config })
                    .then(response => {
                        commit("hideMiniLoader");
                        if (response.data.responseCode !== 200) {
                            throw new Error(response.data.dettagli)
                        }
                        let result = JSON.parse(response.data.result);
                        commit("hideMiniLoader");
                        commit("allNotificheLoaded", result)
                    }).catch(ex=>{
                    commit("hideMiniLoader");
                    commit('addMessage', {
                        message:"VUEX viewAllNotifiche error: "+ex.message,
                        messageType:'error'
                    });
                });

            } catch (e) {
                commit('removeRequest');
                commit("hideMiniLoader");
                commit('addMessage', {
                    message: "VUEX viewAllNotifiche error: " + e.message,
                    messageType: 'error'
                });
            }
        },

        gestisciNotifica({ commit }, data) {
            commit('startGestioneNotifica', data);
        },
        showDettaglioNotifica({ commit }, data){
            commit('showDettaglioNotifica', data);
        },
        reopenTutteLeNotifiche({ commit }, data){
            commit("reopenTutteLeNotifiche")
        }
    },
    getters: {
        getNotifiche: (state) => () => {
            return [...state.notifiche]
        },
    }
}

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}


function epochToDate(epoch) {
    return moment.unix(epoch).format("DD/MM/YYYY HH:mm")
}
export { NotificheStore };